(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cayo-image-compare"] && !Shopify.designMode) return;
  try {
    class CayoImageCompare extends HTMLElement {
    connectedCallback() {
      this.before = this.querySelector('[data-before]');
      this.line = this.querySelector('[data-line]');
      this.knob = this.querySelector('[data-knob]');
      if (!this.before || !this.line || !this.knob) return;

      this.dragging = false;
      this.set(parseFloat(this.dataset.start) || 46);

      this.addEventListener('pointerdown', (e) => {
        this.dragging = true;
        this.setPointerCapture(e.pointerId);
        this.fromEvent(e);
      });
      this.addEventListener('pointermove', (e) => {
        if (this.dragging) this.fromEvent(e);
      });
      const stop = () => { this.dragging = false; };
      this.addEventListener('pointerup', stop);
      this.addEventListener('pointercancel', stop);

      this.knob.addEventListener('keydown', (e) => {
        const step = e.shiftKey ? 10 : 4;
        if (e.key === 'ArrowLeft') { this.set(this.value - step); e.preventDefault(); }
        if (e.key === 'ArrowRight') { this.set(this.value + step); e.preventDefault(); }
      });
    }

    fromEvent(e) {
      const r = this.getBoundingClientRect();
      if (!r.width) return;
      this.set(((e.clientX - r.left) / r.width) * 100);
    }

    set(pct) {
      // keep both images readable at the extremes rather than wiping one out entirely
      this.value = Math.min(96, Math.max(4, pct));
      const v = this.value + '%';
      this.before.style.clipPath = 'inset(0 0 0 ' + v + ')';
      this.line.style.left = v;
      this.knob.style.left = v;
      this.knob.setAttribute('aria-valuenow', Math.round(this.value));
    }
  }

  if (!customElements.get('cayo-image-compare')) {
    customElements.define('cayo-image-compare', CayoImageCompare);
  }
  } catch(e) { console.error(e); }
})();

})();
